import React from 'react';
import {RFValue} from 'react-native-responsive-fontsize';
import {ParcelasDTO} from '../../../../../../../dtos/ParcelasDTO';
import {useHelpers} from '../../../../../../../context/helpers';
import {
  Container,
  InfoBanner,
  InfoBannerText,
  Item,
  ItemName,
  ItemTitle,
  Section,
} from './styles';

type Props = {
  numero_parcela: number;
  data_vencimento: string;
  totalValue: number;
  installment?: ParcelasDTO | null;
  serviceTaxValue: number;
  serviceTaxIsCard: boolean;
  baseValue: number;
  usaBaratinhas: boolean;
  descontoBaratinhas: number;
};

function formatDate(dateStr: string): string {
  const parts = dateStr.split('T')[0].split('-');
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

export function EmprestimoResume({
  numero_parcela,
  data_vencimento,
  totalValue,
  installment,
  serviceTaxValue,
  serviceTaxIsCard,
  usaBaratinhas,
  descontoBaratinhas,
}: Props) {
  const {formatNumberToLocaleAmount} = useHelpers();

  function formatMoeda(value: number) {
    return value.toLocaleString('pt-BR', {currency: 'BRL', style: 'currency'});
  }

  return (
    <Container>
      <InfoBanner>
        <InfoBannerText>
          O valor da parcela será quitado junto à instituição financeira após a confirmação do pagamento.
        </InfoBannerText>
      </InfoBanner>

      <Section style={{paddingBottom: RFValue(6)}}>
        <Item>
          <ItemTitle>Parcela</ItemTitle>
          <ItemName>{numero_parcela}</ItemName>
        </Item>

        <Item>
          <ItemTitle>Vencimento</ItemTitle>
          <ItemName>{formatDate(data_vencimento)}</ItemName>
        </Item>

        {!serviceTaxIsCard && serviceTaxValue > 0 && (
          <Item>
            <ItemTitle>Taxa</ItemTitle>
            <ItemName>{formatMoeda(serviceTaxValue)}</ItemName>
          </Item>
        )}

        {usaBaratinhas && (
          <Item>
            <ItemTitle>BaratinhaZ</ItemTitle>
            <ItemName>-{formatNumberToLocaleAmount(descontoBaratinhas)}</ItemName>
          </Item>
        )}

        {serviceTaxIsCard && serviceTaxValue > 0 && (
          <Item>
            <ItemTitle>Juros (Menor do Brasil)</ItemTitle>
            <ItemName>{serviceTaxValue.toFixed(2).replace('.', ',')}% a.m</ItemName>
          </Item>
        )}

        {installment && installment.installmentCount > 1 && (
          <Item>
            <ItemTitle>Parcelamento</ItemTitle>
            <ItemName>
              {installment.installmentCount}x de {formatMoeda(installment.valorMes)}
            </ItemName>
          </Item>
        )}

        <Item>
          <ItemTitle>Total</ItemTitle>
          <ItemName>{formatMoeda(totalValue)}</ItemName>
        </Item>
      </Section>
    </Container>
  );
}
